import React from "react";
import { useTranslation } from "react-i18next";
import TopMenu from "../../components/TopMenu/TopMenu";
import "./FacilitadorHome.css";
import BottomNav from "../../components/BottomNav/BottomNav";

export default function FacilitadorHome() {
  const { t } = useTranslation();
  
  return (
    <div className="facilitador-home-page">
      <TopMenu />

      <main className="facilitador-home-content">
        <div className="facilitador-cards">
          <div className="facilitador-card">
            <span className="facilitador-card-title">
              {t("pages.facilitadorHome.facilitadores")}
            </span>
            <span className="facilitador-card-subtitle">
              {t("pages.facilitadorHome.escalaSubtitle")}
            </span>
          </div>

          <button
            className="facilitador-card facilitador-card-button"
            onClick={() => {
              window.location.href = "/plantao";
            }}
          >
            <span className="facilitador-card-title">
              {t("pages.facilitadorHome.facilitadores")}
            </span>
            <span className="facilitador-card-subtitle">
              {t("pages.facilitadorHome.inserirNova")}
            </span>
          </button>
        </div>
      </main>
      <BottomNav />
    </div>
  );
}


